function detailInit() {

    $('.p-detail-inner-header').before($('.flags.flags-default'))

    const readMore = $('<a href="#" data-scroll-to="#product-detail">Celý popis</a>')

    readMore.appendTo($('.p-short-description'));

    $('[data-scroll-to]').on('click', function (e) {
        e.preventDefault();
        const target = $(this).data('scroll-to');
        if (target) {
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 1000);
        }
    });
}

